const getMissingFieldsToSavePart = (part = {}) => {

    const requiredFields = [
        { key: 'value' },
        { key: 'partTypeId' },
        { key: 'isRepresented' }
    ];

    return requiredFields
        .map((field) => field.key)
        .filter((fieldKey) => {
            const fieldValue = part[fieldKey];

            if (typeof fieldValue === 'boolean')
                return false;

            if (typeof fieldValue === 'string')
                return fieldValue.trim() === '';

            return fieldValue == null;
        });
}

const requestPartService = {
    getMissingFieldsToSavePart
}

export default requestPartService
